module.exports = {
	init: function(){
		mediaSwitchFlag = 'pc';
		this.mediaSwitchImg();
		this.tellink();
	},
	getWindowSize: function() {
		var ua = navigator.userAgent.toLowerCase(),
			ios92 =  /(iphone|ipod|ipad).* os 9_2/.test(ua);//iOS9.2系でwidth,heightが違う値で返ってくるためそれ用
		var wW = (ios92) ? document.documentElement.clientWidth : window.innerWidth,
			wH = (ios92) ? document.documentElement.clientHeight : window.innerHeight;
		return {
			'width': wW,
			'height': wH
		}
	},
	getEnvironment: function() {
		var userAgent = window.navigator.userAgent.toLowerCase(),
			appVersion = window.navigator.appVersion.toLowerCase(),
			browser, device, software, media;
		//ブラウザ
		if (userAgent.indexOf("msie") != -1) {
			if (appVersion.indexOf("msie 9.") != -1) {
				browser = 'ie9';
			} else if (appVersion.indexOf("msie 10.") != -1) {
				browser = 'ie10';
			} else {
				browser = 'ie';
			}
		} else if (userAgent.indexOf('chrome') != -1) {
			browser = 'chrome';
		} else if (userAgent.indexOf('safari') != -1) {
			browser = 'safari';
		} else if (userAgent.indexOf('gecko') != -1) {
			browser = 'gecko';
		} else {
			browser = false;
		}
		//デバイス
		if (userAgent.indexOf('ipad') > 0 || userAgent.indexOf('android') > 0 && userAgent.indexOf('mobile') < 0) {
			device = 'tab';
		} else if (userAgent.indexOf('iphone') > 0 || userAgent.indexOf('iPod') > 0 || userAgent.indexOf('android') > 0) {
			device = 'sp';
		} else {
			device = 'pc';
		}
		//OS
		if(userAgent.indexOf('android') > 0){
			software = 'android';
		} else if (userAgent.indexOf('iphone') > 0 || userAgent.indexOf('iPod') > 0 || userAgent.indexOf('ipad') > 0) {
			software = 'ios';
		} else if (userAgent.indexOf('windows') > 0) {
			software = 'windows';
		} else if (userAgent.indexOf('Mac') > 0) {
			software = 'mac';
		}
		//画面幅(media)
		if (browser === 'ie9') {
			media = ($('body').css('min-width') == '100%') ? 'sp' : 'pc';
		} else {
			media = (window.matchMedia('(max-width:767px)').matches) ? 'sp' : 'pc';
		}
		return {
			'browser': browser,
			'device': device,
			'software': software,
			'media': media
		}
	},
	getScrollValue: function() {
		var top = $(window).scrollTop();
		return top;
	},
	scrollPageTop: function(target){
		$(target).animate({scrollTop: 0}, 400);
	},
	mediaSwitchImg: function(){
		var media = common_ui.getEnvironment().media,
			before = media === 'sp' ? '_pc' : '_sp',
			after = media === 'sp' ? '_sp' : '_pc';
		if(mediaSwitchFlag !== media){
			mediaSwitchFlag = common_ui.getEnvironment().media;
			$.each($('.js_mediaSwitchImg'), function() {
				$(this).attr('src', $(this).attr('src').replace(before, after));
			});
		}
	},
	hoverImg: function(){
		if(common_ui.getEnvironment().media === 'pc'){
			$('.js_hoverImg').hover(function(){
				$(this).attr('src', $(this).attr('src').replace('_off', '_on'));
			},function(){
				$(this).attr('src', $(this).attr('src').replace('_on', '_off'));
			});
		}
	},
	tellink: function(){
		$('a[href^="tel:"]').on('click', function(event) {
			common_ui.getEnvironment().media === 'pc' && event.preventDefault();
		});
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/modules/common_ui.js
// module id = 2
// module chunks = 0